// Replaced at container start by start.sh, like every *_PLACEHOLDER in the bundle.
export const KODLY_WIDGET_ORIGIN =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_KODLY_WIDGET_ORIGIN || "http://localhost:5173"
    : "REACT_APP_KODLY_WIDGET_ORIGIN_PLACEHOLDER";
